import { companyAge } from "@utils/companyAge";

export const counterData = [
  {
    id: "c.01",
    label: <>Years of Industry <br /> Experience</>,
    value: companyAge,
    suffix: "+",
  },
  {
    id: "c.02",
    label: <>Successful Projects <br /> Delivered</>,
    value: 500,
    suffix: "+",
  },
  {
    id: "c.03",
    label: <>Client Satisfaction <br /> Rate</>,
    value: 98,
    suffix: "%",
  },
  {
    id: "c.04",
    label: "Global delivery centers across the world",
    value: 12,
    suffix: "+",
  },
];